const MAX_EMAIL_LENGTH = 319;
export function emailValid(email: string): boolean {
  if (!email) {
    return false;
  }
  if (email.indexOf("　") !== -1) {
    return false;
  }
  if (email.indexOf(" ") !== -1) {
    return false;
  }
  if (email.length > MAX_EMAIL_LENGTH) {
    return false;
  }
  const pattern = /.+@.+\..+/;
  return pattern.test(email);
}
export function passwordValid(password: string): boolean {
  const pattern = /^([a-zA-Z0-9!-/:-@¥[-`{-~]{6,12})$/;
  return pattern.test(password);
}
/**
 * 電話番号チェック 半角数値10or11桁
 *
 * @param {string} password パスワード
 * @return boolean
 */
export function phoneNumberValid(phoneNumber: string): boolean {
  const pattern = /^([0-9]{10,11})$/;
  return pattern.test(phoneNumber);
}

export function cardNameValid(cardName: string): boolean {
  const pattern =
    /^(?=[A-Za-z0-9.-]*[A-Za-z])[A-Za-z0-9.-]+\s(?=[A-Za-z0-9.-]*[A-Za-z])[A-Za-z0-9.-]+$/;
  // const allowedChars = /[A-Za-z0-9]+/;
  if (!cardName) {
    return false;
  }
  if (cardName.length > 45) {
    return false;
  }
  if (cardName.includes("　")) {
    return false;
  }
  // if (!allowedChars.test(cardName.split(" ")[0])) {
  //   return false;
  // }
  return pattern.test(cardName);
}
